import { Component, OnInit } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import Utils from 'src/app/utils';

declare var bootstrap: any;
import * as _ from 'lodash-es';
import moment from 'moment';
declare var require: any;

@Component({
  selector: 'app-monitoring-scheduling',
  templateUrl: './monitoring-scheduling.component.html',
  styleUrl: './monitoring-scheduling.component.scss'
})
export class MonitoringSchedulingComponent {

  u = Utils;

  account:any;
  view:any;
  times:any;

  formGroup = new FormGroup({
    arc_schedule: new FormControl(false,[])
  });

  submitted = false;

  events:any = [];
  shifts:any = [];
  timezone:any = '';

  calendarOptions:CalendarOptions = {
    initialView:'dayGridMonth',
    plugins: [dayGridPlugin,interactionPlugin]
  }

  deepChangeDetection = true;
  
  dayGroup = new FormGroup({
    start: new FormControl('',[Validators.required]),
    end: new FormControl('',[Validators.required])
  });
  get f(): { [key: string]: AbstractControl } {
    return this.dayGroup.controls;
  }

  day_hours = Utils.getDayHoursPlusOne();

  month:any;
  edit_day:any = null;
  edit_day_str:any = null;

  batch_times:any = Utils.getDayHoursPlusOne();

  copyGroup:any = null;
  batchGroup:any = null;
  batch_dates: any;
  batch_loading = false;

  alert_message = "";

  constructor(public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.getAccount();

    this.batchGroup = new FormGroup({
      start: new FormControl('',[]),
      end: new FormControl('',[]),
      start_time: new FormControl('',[Validators.required]),
      end_time: new FormControl('',[Validators.required]),
      mon: new FormControl(false,[]),
      tue: new FormControl(false,[]),
      wed: new FormControl(false,[]),
      thu: new FormControl(false,[]),
      fri: new FormControl(false,[]),
      sat: new FormControl(false,[]),
      sun: new FormControl(false,[]),
    });

    this.batch_times[0] = {"value":"remove","name":"Remove"};
    // console.log('batch times',this.batch_times);
    this.batch_dates = { startDate: moment(), endDate: moment() };

  }

  getAccount(){

    this.okService.get("account",[])
    .subscribe((data) => {

      this.account = data.body;

      // console.log('account',this.account.arc_schedule);

      this.formGroup.setValue({
        arc_schedule: this.account.arc_schedule
      });

      this.getTimes();

    });

  }

  getTimes(){

    let values:any;

    values = [];
    // console.log('month',this.month);
    if(this.month){
      values["month"] = this.month;
    }

    this.okService.get("smc",values)
    .subscribe((data:any) => {

      this.times = data.body;

      // console.log('times',this.times);

      this.setupEvents();

    });

  }

  setupEvents(){

    this.events = [];

    for (const shift of this.times) {

      let event = {
        title: shift.start_str,
        date: shift.date,
        type: 'start',
        // start: moment(shift.date+" "+shift.time),
        backgroundColor: '#12a000',
        borderColor: '#12a000',
        order: 0,
        allDay: true,
      };
      this.events.push(event);
      
      let event2 = {
        title: shift.end_str,
        date: shift.date,
        type: 'start',
        // start: moment(shift.date+" "+shift.time),
        backgroundColor: '#ffac1e',
        borderColor: '#ffac1e',
        order: 1,
        allDay: true,
      };
      this.events.push(event2);
        
    }

    // console.log('events',this.events);

    this.calendarOptions = {
      initialView: 'dayGridMonth',
      themeSystem: 'bootstrap5',
      events: this.events,
      eventOrder: 'order',
      eventClick:  this.handleEventClick.bind(this),
      dateClick:  this.handleDateClick.bind(this),
      datesSet: this.handleDatesSetClick.bind(this),
      plugins: [dayGridPlugin,interactionPlugin],

    };

  }

  handleDateClick(arg:any) {
    let date = arg.dateStr;
    this.editDayTime(date);
  }

  handleEventClick(arg:any) {
    let date = moment(arg.event.start).format('YYYY-MM-DD');
    this.editDayTime(date);
  }

  handleDatesSetClick(arg:any) {
    // console.log('arg',arg);

    let month = moment(arg.start).add(7, 'days').format('MMM YYYY');
    // console.log('month',month);
    this.month = month;
    this.getTimes();

  }
  
  editDayTime(date:string){

    // console.log('date',date);

    this.edit_day = date;
    this.edit_day_str = moment(date).format('dddd, MMMM Do YYYY');

    let dates = _.filter(this.times, function(o:any) { return o.date==date; });

    // console.log('dates',dates);

    this.dayGroup.setValue({
        start: dates[0] ? dates[0].start_str : "",
        end: dates[0] ? dates[0].end_str : ""
    })

    var myModal = new bootstrap.Modal(document.getElementById('editDayModal'));
    myModal.show();

  }

  submitForm(){

    this.submitted = true;

    if(this.formGroup.valid){

      let values = this.formGroup.value;

      let body = values.arc_schedule == true ? {"active":"Scheduled"} : {"active":"On"};

      this.okService.put('smc',body)
      .subscribe((data) => {

        this.getAccount();
        // console.log('post put', this.account.arc_schedule);

        this.okService.setAlert(this.transloco.translate("SMC Scheduling has been updated"),'success');

        this.getTimes();
      });

    }

  }

  submitDayForm(){

    let values:any;
    values = this.dayGroup.value;
    // console.log(this.dayGroup.value);
    this.alert_message = "";
    // console.log('dayForm values',values);
    if(values.start && values.end){
      let time = {
          "date":this.edit_day,
          "start":values.start,
          "end":values.end
        };

      // console.log('date time',time);

      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editDayModal'));
      myModal.hide();

      this.okService.put("smc",{time:time})
      .subscribe((data:any) => {

        // console.log('date time',data);

        this.getTimes();

        this.okService.setAlert(this.transloco.translate("SMC has been updated"),'success');

      });
    }else if(!values.start && !values.end){

      let time = {
        "date":this.edit_day
      };

      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editDayModal'));
      myModal.hide();

      this.okService.delete("smc",{time:time})
      .subscribe((data:any) => {

        // console.log(data);

        this.getTimes();

        this.okService.setAlert(this.transloco.translate("SMC has been updated"),'success');


      });
    }else{
      this.alert_message = "Please choose both a start and end time";
    }

  }

  batchUpdate(){
    this.alert_message = "";

    if (
      this.batchGroup.valid
      ) {
        let values = this.batchGroup.value
        // console.log(this.batchGroup.value);
        values.start = this.batch_dates.startDate.format("YYYY-MM-DD")
        values.end = this.batch_dates.endDate.format("YYYY-MM-DD")


        // console.log('dates',values);

        this.batch_loading = true;

        this.okService.put("smc",{batch:values})
        .subscribe((data:any) => {

          // console.log(data);

          this.batch_loading = false;

          var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('batchModal'));
          myModal.hide();


          this.getTimes();

          this.okService.setAlert(data.body['message'],"success");

        });

      }else{
        this.alert_message = "Please choose a start and end time."
      }

  }

}
